export enum PhoneType {
    Mobile = 'Mobile',
    Home = 'Home'
}
